import React, { useCallback, useEffect } from "react";
import styled from "styled-components";
import { useScroll } from "../hooks/useScroll";
import { device } from "../styles/media-query";
import { useInView } from "react-intersection-observer";
import { useMyMediaQuery } from "../hooks/useMediaQuery";

const Container = styled.section`
  padding: 20rem 14rem;
  ${device.tablet} {
    padding: 12rem 6rem;
  }
  ${device.mobile} {
    padding: 12rem 2rem;
  }
  ${device.desktop} {
    max-width: 1080px;
    padding: 20rem 4rem;
    margin: 0 auto;
  }
  display: flex;
  flex-direction: column;
`;

const TextContainer = styled.div`
  position: relative;
  width: 100%;
  font-size: 8rem;

  line-height: 10rem;

  ${device.tablet} {
    line-height: 9rem;
    font-size: 7rem;
  }

  ${device.mobile} {
    line-height: 5.2rem;
    font-size: 4.5rem;
  }

  align-content: center;
  overflow: hidden;
  align-items: center;
  height: 115%;
  display: inline-flex;
`;

const Text = styled.div`
  color: white;
  font-weight: bold;
  position: relative;
`;

const Mask = styled.div<{ xPercent?: number }>`
  opacity: 0.65;
  background: #000;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  transform-origin: 100% 50%;
  ${device.desktop} {
    transition: transform 0.4s;
  }
  transition: transform 0.3s;
`;

const TEXT_LIST_DESKTOP = [
  "we create the",
  "tangible blockchain",
  "projects",
  "and cultivate a new wave ",
  "of web3 technology",
];

const TEXT_LIST = [
  "we create the",
  "tangible blockchain",
  "projects",
  "and cultivate a ",
  "new wave of",
  "web3",
  "technology",
];

function Mission() {
  const { isDesktop } = useMyMediaQuery();
  const { ref, inView } = useInView();
  const windowHeight = window.innerHeight;
  const currentScrollY = useScroll();

  function transformMask(index: number, value: number) {
    const maskEl = document.getElementById(`mask_${index}`);

    if (maskEl) {
      maskEl.style.transform = `translateX(${value}%)`;
    }
  }

  const drawMask = useCallback(() => {
    if (currentScrollY && inView) {
      for (let index = 0; index < TEXT_LIST.length; index++) {
        const textElement = document.getElementById(`mission_text_${index}`);
        if (textElement) {
          const { offsetTop, clientHeight } = textElement;
          const height =
            currentScrollY - offsetTop + windowHeight - clientHeight;
          const value = ((3 * height) / (windowHeight + clientHeight)) * 100;

          if (value < 0 || value > 150) continue;

          transformMask(index, value);
        }
      }
    }
  }, [currentScrollY, inView, windowHeight]);

  useEffect(() => {
    drawMask();
  }, [drawMask]);

  return (
    <Container id={"mission"} ref={ref}>
      {(isDesktop ? TEXT_LIST_DESKTOP : TEXT_LIST).map((r, index) => (
        <TextContainer id={`mission_text_${index}`} key={index}>
          <Text>
            {r}
            <Mask id={`mask_${index}`} />
          </Text>
        </TextContainer>
      ))}
    </Container>
  );
}

export default Mission;
